<template>
  <button
    class="button is-primary"
    :class="{ 'is-loading': isLoading, 'is-fullwidth': !isInline }"
  >
    {{ title }}
    <spinner class="animated fadeInLeft" v-if="isLoading"></spinner>
  </button>
</template>

<script>
import { Spinner } from 'components/loaders';

export default {
  name: 'GradientButton',
  components: {
    Spinner,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
    isInline: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.button {
  box-shadow: 0 2px 4px 0 rgba(253, 58, 87, 0.24);
  background-image: linear-gradient(103deg, #fd3a57, #fe6d6c 51%, #ff9e80);
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  transition: all 0.1s $timing-function;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  justify-content: center;
  font-family: $family-primary;

  &:hover,
  &.is-hovered,
  &:focus,
  &.is-focused {
    box-shadow: 0 2px 8px 0 rgba(253, 58, 87, 0.4);
  }

  &:focus,
  &.is-focused {
    &:not(:active) {
      box-shadow: 0 2px 8px 0 rgba(253, 58, 87, 0.4);
    }
  }

  &.is-loading {
    &:after {
      display: none;
    }
  }
}
</style>
